module.exports = __webpack_public_path__ + "media/images/img-service-intro-title-855893a218dfb141b372b44669b4bbda.svg";